import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ErrorService } from 'src/app/error.service';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
@Injectable()

export class ReportsService {
  constructor(private http: HttpClient, public errorService: ErrorService) { }

  gettoken() {
    let url = "api/Report/GetAccessToken"
    return this.http.get(url, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  GetAllClientsDropDownbyAgency(): Observable<any> {
    let url = "api/EmployeePayrate/GetcliDD"
    return this.http.get<any>(url, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    );
  }

  getPayorList(paramsData: URLSearchParams): Observable<any> {
    let url = "api/GroupPayor/GetGroupPayorBatch?"
    return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)

    )
  }

  getgroupList(paramsData: URLSearchParams): Observable<any> {
    let url = "api/LOV/getLovDropDown?"
    return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)

    )
  }

  ////////////////////////////////////////getcompany////////////////////////////////
  getCompany(): Observable<[{ Key: number, Value: string }]> {
    let url = "api/Company/CommonGetCompanyList?";
    return this.http.get<[{ Key: number, Value: string }]>(url, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  ////////////////////////////////////////cleRINGHOUSE////////////////////////////////
  getClearinghouse(): Observable<[{ Key: number, Value: string }]> {
    let url = "api/ClearingHouse/getCommonClearingHouselist?";
    return this.http.get<[{ Key: number, Value: string }]>(url, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  Submissionreports(saveList: URLSearchParams): Observable<any> {


    let url = "api/BatchFile/GetBatchFilesreport?";

    return this.http.get<any>(url + saveList, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  Exceptionreports(saveList: URLSearchParams): Observable<any> {


    let url = "api/Import/GetExceptionlist?";

    return this.http.get<any>(url + saveList, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
  getEmployee(): Observable<[{ Key: string, Value: string }]> {
    let url = "api/Client/GetEmpListbyType?"
    return this.http.get<[{ Key: string, Value: string }]>(url, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }


  //////////////////////////////////////////get Client///////////////////////////////////////////////////////

  getClient(): Observable<any> {
    let url = "api/Client/GetClientListbyTd?"
    return this.http.get<any>(url, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
  getpowerbiToken(): Observable<any> {
    let url = "api/PowerBI/GetAccessToken?"
    return this.http.get<any>(url, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    );
  }
  getAllBudgetsForClient(params: URLSearchParams): Observable<any> {
    let url = "api/Budget/getAllBudgetsForClient?"
    return this.http.get<any>(url + params, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    );
  }

  //===========================get Lov=============================================================//
  getfilterList(paramsData: URLSearchParams): Observable<any> {
    let url = "api/LOV/getLovDropDown?"
    return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)

    )
  }

  //===========================get Lov=============================================================//
  getReport(paramsData: URLSearchParams): Observable<any> {
    let url = "api/Client/getInactiveReport?"
    return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)

    )
  }
  //=======================get 835===============================================================//
  get835(): Observable<any> {

    let url = "api/Import/Get835Dropdown?"
    return this.http.get<any>(url, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
  createspendowndlist(paramsData: URLSearchParams): Observable<any> {

    let url = "api/Import/CreatespenDown?"
    return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
  downloadspendowndlist(paramsData: any): Observable<any> {

    let url = "api/Import/printspendown?"
    return this.http.post<any>(url, paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }


  getRevenuePayorList(paramsData: URLSearchParams): Observable<any> {
    let url = "api/GroupPayor/CommonGetGPList?"
    return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)

    )
  }
  getDateLidList(paramsData: URLSearchParams): Observable<any> {
    let url = "api/LOV/getLovDropDown?"
    return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)

    )
  }
  getChargeLidList(paramsData: URLSearchParams): Observable<any> {
    let url = "api/LOV/getLovDropDown?"
    return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)

    )

  }
  getAgingdataList(paramsData: URLSearchParams): Observable<any> {
    let url = "api/LOV/getLovDropDown?"
    return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)

    )

  }
  getRevenueList(paramsData: URLSearchParams): Observable<any> {
    let url = "api/ClaimMaster/GetRevenuesbyPayor?"
    return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)

    )
  }

  getClaimvsPaidListDetails(paramsData: URLSearchParams): Observable<any> {
    let url = "api/ClaimMaster/getClaimChargesVsPaidList?"
    return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)

    )
  }
  getFinancialListDetails(paramsData: URLSearchParams): Observable<any> {
    let url = "api/ClaimMaster/getfinancial?"
    return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)

    )
  }

  getcolumwidth(): Observable<any> {

    let url = "api/ColumnChange/getwidth?";
    return this.http.get<any>(url, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
  savecolumwidth(list: any): Observable<any> {
    let url = "api/ColumnChange/Savewidth?";
    return this.http.post<number>(url, list, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  Exceptionreports835(saveList: URLSearchParams): Observable<any> {
    let url = "api/Import/Get835Exceptionlist?";
    return this.http.get<any>(url + saveList, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  getclaim(paramsData: URLSearchParams): Observable<any> {
    let url = "api/LOV/getLovDropDown?"
    return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  getAgingList(paramsData: URLSearchParams): Observable<any> {
    let url = "api/LOV/getLovDropDown?"
    return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)

    )
  }

  getAgingdaysList(paramsData: URLSearchParams): Observable<any> {
    let url = "api/LOV/getLovDropDown?"
    return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)

    )
  }

  /////////
  SpendDownFunction(params: URLSearchParams): Observable<void> {

    let url = "api/ClaimMaster/getSpendDown?";
    return this.http.get<void>(url + params, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
  MarkSpendDownasPrinted(markasPrinted: any[]): Observable<string> {
    let url = "api/ClaimProcess/MarkSpendDownasPrinted";
    return this.http.post<string>(url, markasPrinted, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
  MarkSpendDownasNotPrinted(markasNotPrinted: any[]): Observable<string> {
    let url = "api/ClaimProcess/MarkSpendDownasNotPrinted";
    return this.http.post<string>(url, markasNotPrinted, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  //==============================get employee permission==========================================//
  getpermission(paramsData: URLSearchParams): Observable<any> {
    let url = "api/FunctionPermission/getfunctionpermissionemployee?";
    return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
}
